import { ChangeDetectionStrategy, Component, DestroyRef, inject, signal, input } from '@angular/core';
import { DropdownMenuService } from './dropdown-menu.service';

@Component({
  selector: 'juno-libs-ui-dropdown-menu',
  imports: [],
  templateUrl: './dropdown-menu.component.html',
  styleUrl: './dropdown-menu.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '(document:click)': 'onDocumentClick()',
    '(document:keydown.escape)': 'hideMenu()',
  },
})
export class DropdownMenuComponent {
  readonly isVisible = signal(false);
  readonly appliedClasses = input('');
  readonly parentDropdown = input<DropdownMenuComponent>();
  readonly #dropdownMenuService = inject(DropdownMenuService);
  readonly #destroyRef = inject(DestroyRef);

  constructor() {
    this.#dropdownMenuService.registerDropdown(this);
    this.#destroyRef.onDestroy(() => this.#dropdownMenuService.unregisterDropdown(this));
  }

  hideMenu(): void {
    this.isVisible.set(false);
  }

  toggleMenu(): void {
    this.isVisible.set(!this.isVisible());
  }

  onDocumentClick() {
    this.hideMenu();
  }
}
